import { Box, Button, Dialog, DialogContent, DialogTitle, Paper, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { buttonStyle, errorTextStyle, titleStyle } from '../../../utils/commonCSS'
import { headingBlue } from '../../../assets/colors'
import CustomTextField from '../../CustomTextField'
import { addContributionField, getContributionFields, getContributionFieldsHierarchy } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { errorStyleText } from '../../formStyle'
import CustomDropDown from '../../CustomDropDown'
import { genderList } from '../../../utils/constants'
import ConfigWORKerContrFields from './ConfigWORKerContrFields'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AddNewContributionFields = (props) => {

  const [fieldsHierarchy, setFieldsHierarchy] = useState([])

  const [addDomain, setAddDomain] = useState(false)

  const [toggle, setToggle] = useState('field')
  const [fieldName, setFieldName] = useState('')
  const [fieldAddError, setAddFieldError] = useState('')

  const [allFields, setAllFields] = useState([])
  const [selectedField, setSelectedField] = useState('Select Domain')
  const [selectedId, setSelectedId] = useState(null)
  const [subFieldName, setSubFieldName] = useState('')
  const [subFieldAddError, setAddSubFieldError] = useState('')

  const [apiError, setApiError] = useState('')

  const updateSelectedField = (value) => {
    setSelectedField(value.name)
    setSelectedId(value._id)
  }

  const handleAddField = () => {
    try{
      let options = {
        url: addContributionField,
        method: 'POST',
        payload: {
          areaName: fieldName,
          areaType: 'parent'
        },
        headers: {
          headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
          }}
      }
      HttpService(options).then((resp) => {
        console.log("Contribution Field Added.")
        setAddDomain(false)
      }).catch(err => {
        console.log('Error in adding new contribution field.')
        setAddFieldError(err?.response?.data?.message)
      })

    } catch(err){
      console.log('Error in adding contribution field: ', err)
      setAddFieldError('Error in adding new contribution field. Please contact support.')
    }
  }

  const handleAddSubField = () => {
    try{
      let options = {
        url: addContributionField,
        method: 'POST',
        payload: {
          areaName: subFieldName,
          areaType: 'child',
          parentId: selectedId
        },
        headers: {
          headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
          }}
      }
      HttpService(options).then(resp => {
        console.log("Sub field added successfully.")
        setAddDomain(false)
        // props.updateFunc(false)
      }).catch(err => {
        console.log("Error in adding new sub field: ", err)
        setAddSubFieldError(err?.response?.data?.message)
      })

    } catch(err) {
      console.log("Error in adding sub field: ", err)
      setAddSubFieldError('Error in adding sub field. Please contact support.')
    }
  }

  useEffect(() => {
    if( toggle === 'subField'){
      let options = {
        url: getContributionFields,
        method: 'GET',
        headers: {
          authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null 
        }
      }
      HttpService(options).then(resp => {
        setAllFields(resp?.data?.data)
      })
    }
  }, [toggle])

  useEffect(() => {
    setAddDomain(false)
    setApiError('')
  }, [props.dialogStatus])

  useEffect(() => {
    try{
      if(props.dialogStatus === true){
        let options = {
          url: getContributionFieldsHierarchy,
          method: 'GET',
          params: {},
          headers: {
            authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
        HttpService(options).then((resp) => {
          setFieldsHierarchy(resp?.data?.data)
        }).catch(err => {
          console.log('Error in fetching contributions fields hierarchy: ', err)
          setApiError('Error in fetching contribution fields hierarchy. Please contact support.')
        })
      }
    } catch(err){
      console.log('Error in fetching the contribution fields hierarchy.')
    }
  }, [props.dialogStatus])


  return (
    <>
    <Dialog maxWidth='xs' fullWidth open={props.dialogStatus} onClose={() => props.updateFunc(false)}>
        <DialogTitle style={titleStyle}>
          Volunteering Domain
        </DialogTitle>
        <DialogContent>
          <>
            {!addDomain &&
              <Box>
                <Box style={{display: 'flex', justifyContent: 'flex-end', padding: '1rem 1rem 0rem 0.3rem'}}>
                  <Button style={{...buttonStyle}}
                    onClick={() => 
                      {
                        setFieldName('')
                        setSelectedField('Select Domain')
                        setSelectedId(null)
                        setSubFieldName('')
                        setAddFieldError(null)
                        setAddSubFieldError(null)
                        setToggle('field')
                        setAddDomain(true)
                      }
                    }
                  >Add Domain</Button>
                </Box>
                
                <ConfigWORKerContrFields settings={true}></ConfigWORKerContrFields>
              </Box>
            }
            
            {addDomain &&
              <>
                <Box style={{padding: '0.5rem 0rem 0rem 0.2rem'}}
                  onClick={() => setAddDomain(false)}
                >
                  <ArrowBackIcon></ArrowBackIcon>
                </Box>
                
                <Box style={{display: 'flex', flexDirection: 'row', padding: '0.3rem 0.2rem 1rem 0.2rem'}}>
                  <ToggleButtonGroup
                    color="primary"
                    value={toggle}
                    exclusive
                    sx={{
                        display: "flex",
                        "& .MuiToggleButton-root": {
                          fontSize: "0.9rem", // Smaller font
                          padding: "4px 8px", // Smaller padding
                          minWidth: "50px",   // Smaller width
                          "&.Mui-selected": {
                            backgroundColor: headingBlue, // Orange color for selected state
                            color: "#fff",
                            }
                        },
                      }}                        
                    onChange={(event) => {
                        setToggle(event.target.value)
                    }}
                >
                    <ToggleButton value='field'>Domain</ToggleButton>
                    <ToggleButton value='subField'>Sub Domain</ToggleButton>

                  </ToggleButtonGroup>
                </Box>
                {toggle === 'field' &&
                <Paper style={{padding: '1rem 0.5rem 1rem 0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <CustomTextField placeHolder="Domain Name" value={fieldName}
                    setFunc = {(value) => {
                      setFieldName(value)
                    }}
                    ></CustomTextField>
                  
                  <Box style={{padding: '0.5rem'}}>
                    <Button style={{...buttonStyle, padding: '0.3rem', opacity: (!fieldName || fieldName === '') ? 0.5 : 1}}
                    disabled={
                      !fieldName || fieldName === ''
                    }
                    onClick={() => handleAddField()}
                    > Add</Button>
                  </Box>
                  <Box style={{display: 'flex', justifyContent: 'center'}}>
                    <Typography style={errorTextStyle}>{fieldAddError}</Typography>
                  </Box>
                </Paper>}

                {toggle === 'subField' &&
                <Paper style={{padding: '1rem 0.5rem 1rem 0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                  <CustomDropDown width='15rem' regular={true} list={allFields} 
                    isValueRequired = {true}
                    placeHolder = 'Select Domain'
                    value = {selectedField}
                    setFunc={updateSelectedField}>
                  </CustomDropDown>
                  <Box style={{padding: '0.5rem 0.2rem 0.2rem 0.2rem'}}>
                    <CustomTextField width='15rem' placeHolder= 'Sub Domain Name'
                      value={subFieldName}
                      setFunc = {(value) => {
                        setSubFieldName(value)
                      }}
                    >
                  </CustomTextField>
                  </Box>
                  
                  <Box style={{padding: '0.5rem'}}>
                    <Button style={{...buttonStyle, padding: '0.3rem', opacity: (!subFieldName || subFieldName === '') ? 0.5 : 1}}
                    disabled={
                      !subFieldName || subFieldName === ''
                    }
                    onClick={() => handleAddSubField()}
                    > Add</Button>
                  </Box>
                  <Box style={{display: 'flex', justifyContent: 'center'}}>
                    <Typography style={errorTextStyle}>{subFieldAddError}</Typography>
                  </Box>
                </Paper>
                }
              </>
            }
          </>  
        </DialogContent>

    </Dialog>
    </>
  )
}

export default AddNewContributionFields
